import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { CombinedContext } from "../../context/combinedContext";
import translations from "../../translations/translations";
import { CheckCircle } from "lucide-react";
import "./homeLanding.css";
import homePageImage1 from "../../images/homePageImages/homepageimage1.png";
import homePageImage4 from "../../images/homePageImages/homepageimage4.png";
import homePageImage9 from "../../images/homePageImages/homepageimage9.png";
import PhoneCarousel from "../common/phoneCarousel/PhoneCarousel";

const HomeLanding = () => {
    const { language } = useContext(CombinedContext);
    const navigate = useNavigate();

    return (
        <div>

            {/* ── HERO ── */}
            <section className="sf-hl-hero">
                <div className="sf-hl-hero-orb1"></div>
                <div className="sf-hl-hero-orb2"></div>
                <div className="sf-hl-hero-inner">
                    <div className="sf-hl-hero-left">
                        <div className="sf-hl-hero-badge">
                            <span className="sf-hl-hero-badge-dot"></span>
                            Sin Fila
                        </div>

                        <h1>{translations[language].homeLanding.hero.title}</h1>

                        <p className="sf-hl-hero-sub">{translations[language].homeLanding.hero.subtitle}</p>

                        <div className="sf-hl-hero-actions">
                            <button className="sf-hl-btn-primary" onClick={() => navigate("/businesslanding")}>
                                {translations[language].homeLanding.hero.primaryCta}
                            </button>
                            <button className="sf-hl-btn-ghost" onClick={() => navigate("/barbershop")}>
                                {translations[language].homeLanding.hero.secondaryCta}
                            </button>
                        </div>

                        <p className="sf-hl-hero-note">
                            <em>
                                <strong>{translations[language].homeLanding.hero.freeTrial}</strong>
                                {translations[language].homeLanding.hero.freeTrialText}
                            </em>
                        </p>

                        <p className="sf-hl-hero-note">
                            <em>
                                <strong>{translations[language].homeLanding.hero.platformStrong}</strong>
                                {translations[language].homeLanding.hero.platformRest}
                            </em>
                        </p>
                    </div>

                    <div className="sf-hl-hero-img-wrap">
                        <img src={homePageImage9} alt="" className="sf-hl-hero-img" />
                    </div>
                </div>
            </section>

            {/* ── PAGE BODY ── */}
            <div className="sf-hl-page">

                {/* WHAT WE DO + PHONE CAROUSEL */}
                <section className="sf-hl-what">
                    <div className="sf-hl-section-head-left">
                        <span className="sf-hl-section-label">{translations[language].homeLanding.whatWeDo.title}</span>
                        <h2>{translations[language].homeLanding.whatWeDo.title}</h2>
                    </div>

                    <div className="sf-hl-what-grid">
                        <ul className="sf-hl-steps">
                            {translations[language].homeLanding.businessPoints.map((p, i) => (
                                <li key={i} className="sf-hl-step-item">
                                    <div className="sf-hl-step-num">{i + 1}</div>
                                    <div className="sf-hl-step-content">
                                        <strong>{p.title}</strong>
                                        <p>{p.desc}</p>
                                    </div>
                                </li>
                            ))}
                        </ul>

                        <div className="sf-hl-phone-wrap">
                            <div className="sf-hl-phone-glow"></div>
                            <PhoneCarousel />
                        </div>
                    </div>
                </section>

                {/* BENEFITS — BUSINESS: image LEFT, card RIGHT */}
                <section className="sf-hl-benefits-section sf-hl-dyk-bg">
                    <div className="sf-hl-benefits-inner">
                        <div className="sf-hl-benefits-img-wrap">
                            <img src={homePageImage1} alt="" className="sf-hl-benefits-img" />
                        </div>

                        <div className="sf-hl-benefits-card">
                            <span className="sf-hl-section-label">{translations[language].homeLanding.business.title}</span>
                            <h3>{translations[language].homeLanding.business.title}</h3>
                            <p className="sf-hl-benefits-intro">{translations[language].homeLanding.business.intro}</p>

                            <ul className="sf-hl-checklist">
                                {translations[language].homeLanding.business.items.map((item, idx) => (
                                    <li key={idx}>
                                        <CheckCircle size={16} className="sf-hl-check-icon" />
                                        {item}
                                    </li>
                                ))}
                            </ul>

                            <button className="sf-hl-btn-primary" onClick={() => navigate("/businesslanding")}>
                                {translations[language].homeLanding.business.cta}
                            </button>
                        </div>
                    </div>
                </section>

                {/* BENEFITS — CLIENTS: card LEFT, image RIGHT */}
                <section className="sf-hl-benefits-section">
                    <div className="sf-hl-benefits-inner">
                        <div className="sf-hl-benefits-card">
                            <span className="sf-hl-section-label">{translations[language].homeLanding.clients.title}</span>
                            <h3>{translations[language].homeLanding.clients.title}</h3>
                            <p className="sf-hl-benefits-intro">{translations[language].homeLanding.clients.intro}</p>

                            <ul className="sf-hl-checklist">
                                {translations[language].homeLanding.clients.items.map((item, idx) => (
                                    <li key={idx}>
                                        <CheckCircle size={16} className="sf-hl-check-icon" />
                                        {item}
                                    </li>
                                ))}
                            </ul>

                            <button className="sf-hl-btn-ghost-dark" onClick={() => navigate("/barbershop")}>
                                {translations[language].homeLanding.clients.cta}
                            </button>
                        </div>

                        <div className="sf-hl-benefits-img-wrap">
                            <img src={homePageImage4} alt="" className="sf-hl-benefits-img" />
                        </div>
                    </div>
                </section>

                {/* HOW IT WORKS */}
                <section className="sf-hl-how sf-hl-cream-bg">
                    <div className="sf-hl-section-head-center">
                        <span className="sf-hl-section-label">{translations[language].homeLanding.about.title}</span>
                        <h2>{translations[language].homeLanding.about.title}</h2>
                    </div>

                    <div className="sf-hl-how-grid">
                        <div className="sf-hl-how-step">
                            <div className="sf-hl-how-circle">
                                <strong>{translations[language].homeLanding.about.step1}</strong>
                                <span>{translations[language].homeLanding.about.step1Text}</span>
                            </div>
                            <p>{translations[language].homeLanding.about.paragraph1}</p>
                        </div>

                        <div className="sf-hl-how-connector" aria-hidden="true"></div>

                        <div className="sf-hl-how-step">
                            <div className="sf-hl-how-circle">
                                <strong>{translations[language].homeLanding.about.step2}</strong>
                                <span>{translations[language].homeLanding.about.step2Text}</span>
                            </div>
                            <p>{translations[language].homeLanding.about.paragraph2}</p>
                        </div>

                        <div className="sf-hl-how-connector" aria-hidden="true"></div>

                        <div className="sf-hl-how-step">
                            <div className="sf-hl-how-circle">
                                <strong>{translations[language].homeLanding.about.step3}</strong>
                                <span>{translations[language].homeLanding.about.step3Text}</span>
                            </div>
                            <p>{translations[language].homeLanding.about.paragraph3}</p>
                        </div>
                    </div>
                </section>

                {/* FINAL CTA */}
                <section className="sf-hl-final">
                    <p>{translations[language].homeLanding.finalCta.text}</p>
                    <button className="sf-hl-btn-primary" onClick={() => navigate("/businesslanding")}>
                        {translations[language].homeLanding.business.cta}
                    </button>
                </section>

                {/* TESTIMONIALS */}
                <section className="sf-hl-testimonials">
                    <div className="sf-hl-section-head-center">
                        <h2>{translations[language].homeLanding.testimonials.title}</h2>
                    </div>
                    <div className="sf-hl-testimonial-grid">
                        <div className="sf-hl-testimonial-placeholder">TESTIMONIALS</div>
                        <div className="sf-hl-testimonial-placeholder">TESTIMONIALS</div>
                        <div className="sf-hl-testimonial-placeholder">TESTIMONIALS</div>
                    </div>
                </section>

            </div>
        </div>
    );
};

export default HomeLanding;
